var ChartingFlowRouteName;
(function (ChartingFlowRouteName) {
    ChartingFlowRouteName["PRINT_REQUISITION_FORMS"] = "ChartingFlow/PrintRequisitionForms";
    ChartingFlowRouteName["SPECIMEN_BAGS"] = "ChartingFlow/SpecimenBags";
})(ChartingFlowRouteName || (ChartingFlowRouteName = {}));

export { ChartingFlowRouteName };
